export const codePattern = /^\d{4}$/;
export const usPhonePattern = /^\+1\s?\d{3}\s?\d{3}\s?\d{4}$/;
export const uaPhonePattern = /^\+380\s?\d{2}\s?\d{3}\s?\d{2}\s?\d{2}$/;
